enum Module {
  // Moudules name
  name = "homeModules",
  desc = "homeModules/",
}

enum Mutations {
  SetMyHostingMeetingNumber = "updateMyHostingMeetingNumbers",
  SetMyParticipantMeetingNumber = "updateMyParticipantMeetingNumbers",
  SetMyHostingMeetings = "updateMyHostingMeetings",
  SetMyParticipantMeetings = "updateMyParticipantMeetings",
  SetEventStatuses = "updateEventStatuses",
  SetUserResponseStatuses = "updateUserResponseStatuses",
  SetReloadParticipantEventsFlag = "setReloadParticipantEventsFlag",
  SetMyRecordMeetings = 'setMyRecordMeetings'
}

enum Actions {
  HandEventStatuses = "getEventStatuses",
  HandUserResponseStatuses = "getUserResponseStatuses",
  HandMyHostingEvents = "getMyHostingEvents",
  HandMyParticipantEvents = "getMyParticipantEvents",
  UpdateReloadParticipantEventsFlag = "updateReloadParticipantEventsFlag",
  HandMyRecordEvents = "getMyRecordEvents",
}

enum Getters {
  EventStatuses = "getEventStatuses",
  UserResponseStatuses = "getUserResponseStatuses",
  MyHostingEventNumber = "getMyHostingEventNumber",
  MyParticipantEventNumber = "getMyParticipantEventNumber",
  MyHostingEvents = "getMyHostingEvents",
  TheHostingEvent = "getTheHostingEvent",
  MyParticipantEvents = "getMyParticipantEvents",
  TheParticipantEvent = "getTheParticipantEvent",
  NeedReloadParticipantEventsFlag = "getReloadParticipantEventsFlag",
  MyHostingTimeRange = 'getMyHostingTimeRange',
  MyRecordTimeRange = 'getMyRecordTimeRange',
  MyRecordEvents = 'getMyRecordEvents',
  TheRecordEvent = 'getRecordEvent'
}

export { Module, Actions, Mutations, Getters };
